<!------------------------------------------- template ------------------------------------------->
<template>
  <view class="page-header" :style="getHeaderStyle">
    <view class="page-header-body" :style="getHeaderStyle">{{ title }}</view>
  </view>
</template>

<!-------------------------------------------- script -------------------------------------------->
<script>
export default {
  name: '',
  components: {
  },
  options: {
    virtualHost: true
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      menuRect: {}
    }
  },

  /* 一.生命周期函数 */
  created () {
    const { uniPlatform } = uni.getSystemInfoSync()

    switch (uniPlatform) {
      case 'app':
      case 'web':
        this.menuRect = {
          top: 16,
          height: 18
        }
        break;
      default:
        this.menuRect = uni.getMenuButtonBoundingClientRect()
        break;
    }
    // 
  },

  /* 二.监控函数 */
  watch: {
  },

  computed: {
    getHeaderStyle () {
      let str = ''
      if (this.menuRect?.top) {
        str += `padding-top: ${this.menuRect?.top}px;`
        str += `height: ${this.menuRect?.top + this.menuRect?.height + 16}px;`
      }
      if (this.color) {
        str += `color: ${this.color};`
      }
      if (this.background) {
        str += `background: ${this.background};`
      }
      return str
    }
  },

  /* 三.内部功能函数 */
  methods: {
    /* ----------------------事件调用函数------------------------ */
    // 事件调用函数注释
    actionXxx () {

    },

    /* ----------------------内部功能函数------------------------ */
    // 内部功能函数注释
    doSomething () {

    },

    /* ----------------------服务请求函数------------------------ */
    // 服务请求函数注释
    ajaxXxx () {

    }
  }
}
</script>

<!-------------------------------------------- style -------------------------------------------->
<style scoped lang="scss">
.page-header{
  text-align: center;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36rpx;
  font-weight: 500;
  &-body{
    position: fixed;
    z-index: 10;
    left: 0;
    top: 0;
    width: 100%;
  }
}
</style>
